import { Component, Input, HostBinding, OnInit } from '@angular/core';

@Component({
	selector: 'bb-loading',
	templateUrl: './bb-loading.component.html',
	styleUrls: ['./bb-loading.component.scss']
})

export class BbLoadingComponent implements OnInit {
	@HostBinding('style.width.px') width: number;
	@HostBinding('style.height.px') height: number;
	@HostBinding('style.top') top: string;
	@Input() size = 100;
	@Input() renderInline = false;
	@HostBinding('class.inline') get inline(): boolean {
		return this.renderInline;
	};

	ngOnInit() {
		this.width = this.size;
		this.height = this.size;
		this.top = 'calc(50% - ' + (this.size / 2) + 'px)';
	}
}
